import axios from 'axios'
import C from './Confg';
import S from '../lib/Security'
import N from '../lib/Network'
var CryptoJS = require("crypto-js");

const Utils = {

    getRoleStatus: function(roleId) {
        let data = JSON.parse(localStorage.getItem("activity"));
        let promise = new Promise((resolve, reject) => {
            data.map((item,i) => {
                if (item.activityId === roleId) {
                    var id = item.activityId;
                    resolve(true);
                } else {
                    resolve("roleId");
                }
            })
        });
        return promise;
    },

    getKeys: () => {
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
            N.getRSAApi('/getRsaKeys')
            .then(res => {
                let resObj = JSON.parse(res.data);
                let resJson = JSON.parse(resObj.responseJson);
                if(resJson.privateKey && resJson.publicKey){
                    let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                    // Decrypt
                    var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                    S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
                    console.log("privateKey:"+JSON.stringify(S.privateKey))
        
                    var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                    S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                    console.log("publicKey:"+JSON.stringify(S.publicKey))
    
                    // fetchOcrReportData();
                    
                }
            })
            .catch(err => {
                console.log("Error : "+err);
            });
        }
      }

}

const createDateFormat = {
    day: "",
    month: "",
    year: "",
    hours: "",
    minutes: "",
    seconds: "",
  
    createCurrentDate: () => {
      const date = new Date();
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getFullYear()).slice(-2)}`;
    },
  
    splitDate: (dateString) => {
      const parts = dateString.split(/[-\s:]/); // Split by dash, space, or colon
      if (parts.length === 5) {
        // Assuming the format is DD-MM-YYYY hh:mm
        [
          createDateFormat.day,
          createDateFormat.month,
          createDateFormat.year,
          createDateFormat.hours,
          createDateFormat.minutes,
        ] = parts;
      } else if (parts.length === 6) {
        // If the format is DD-MM-YYYY hh:mm:ss (with seconds)
        [
          createDateFormat.day,
          createDateFormat.month,
          createDateFormat.year,
          createDateFormat.hours,
          createDateFormat.minutes,
          createDateFormat.seconds,
        ] = parts;
      } else {
        throw new Error("Unsupported date format");
      }
    },
  
    // Method to format based on the initial date format
    format: (initialDateFormat) => {
      switch (initialDateFormat) {
        case "DD-MM-YYYY hh:mm":
          return new Date(
            `${createDateFormat.year}-${createDateFormat.month}-${createDateFormat.day}T${createDateFormat.hours}:${createDateFormat.minutes}:00`
          );
  
        case "DD-MM-YYYY hh:mm:ss":
          return new Date(
            `${createDateFormat.year}-${createDateFormat.month}-${createDateFormat.day}T${createDateFormat.hours}:${createDateFormat.minutes}:${createDateFormat.seconds}`
          );
  
        case "YYYY-MM-DD hh:mm":
          return new Date(
            `${createDateFormat.year}-${createDateFormat.month}-${createDateFormat.day}T${createDateFormat.hours}:${createDateFormat.minutes}:00`
          );
  
        case "YYYY-MM-DD hh:mm:ss":
          return new Date(
            `${createDateFormat.year}-${createDateFormat.month}-${createDateFormat.day}T${createDateFormat.hours}:${createDateFormat.minutes}:${createDateFormat.seconds}`
          );
  
        // Handle other cases
        default:
          throw new Error("Unsupported date format");
      }
    },
  };

  const parseObject = (responseMetadata, schema) => {
    const parsedMetadata = {};
  
    Object.keys(schema).forEach(key => {
      const referenceValue = schema[key];
      const responseValue = responseMetadata[key];
      
      // Typecast based on the reference type
      if (typeof referenceValue === 'number') {
        parsedMetadata[key] = Number(responseValue);
      } else if (typeof referenceValue === 'boolean') {
        parsedMetadata[key] = responseValue === 'true';
      } else {
        parsedMetadata[key] = responseValue;
      }
    });
  
    return parsedMetadata;
  };

  const deepEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true; 
  
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return false; // One is not an object or one is null
    }
  
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) return false; // Different number of properties
  
    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false; // Key missing or values don't match
      }
    }
  
    return true; // Objects are deeply equal
  }

export {createDateFormat, Utils, parseObject, deepEqual};